import { render, staticRenderFns } from "./OsParticipantPdfDownloadBtn.vue?vue&type=template&id=15b08992&scoped=true"
import script from "./OsParticipantPdfDownloadBtn.vue?vue&type=script&lang=ts"
export * from "./OsParticipantPdfDownloadBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b08992",
  null
  
)

export default component.exports